module.exports = __webpack_public_path__ + "static/img/shanghai4.e9938be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/shanghai4.jpg
// module id = T15/
// module chunks = 1